import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import ProductionStatusLabel from "../../../../productions/components/ProductionStatus/ProductionStatusLabel";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";
import truncateString from "../../../../ui/utils/truncateString";

export default function useUpcomingDeliveriesColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "title",
			Header: t("title"),
			collapsing: true,
			Cell: ({ row }) => {
				return (
					<Flex justifyContent="flex-start">
						<div style={{ marginRight: "1em", height: 45, width: 45 }}>
							<CoverImage thumb rounded data={row} size={45} style={{ margin: "0 auto" }} />
						</div>

						<div>{truncateString(row.title, 30)}</div>
					</Flex>
				);
			},
		},
		{
			id: "status",
			Header: t("status", "Status"),
			collapsing: true,
			Cell: ({ value }) => <ProductionStatusLabel status={value} />,
		},
		{
			id: "deliveryDate",
			Header: t("deliveryDate", "Delivery date"),
			accessor: ({ deliveryDate }) => deliveryDate?.toDate?.().toLocaleDateString(),
		},
	];
}
